import { DataTable } from "@appretio/ui-kit";
import { useMemo } from "react";
import { TopTenResponse } from "../../pages/inSeasonReviewPage/hooks/useFetchTopTen";
import { useCalculateHitRate } from "./hooks/useCalculateHitRate";
import * as styles from "./TopTenDataTables.css";
import { createColumnDefinitions } from "./utils/columnsDefinition";
import { getRowStyleForCrossTableComparison } from "./utils/getRowStyleForCrossTableComparison";

const RANKING_LABELS = {
  SALES: "Sales",
  PURCHASE: "Purchase",
  HIT_RATE: "Hit Rate"
} as const;

const ROW_SELECTION_CONFIG = {
  mode: "singleRow" as const,
  checkboxes: false,
  enableClickSelection: false
};

interface TopTenDataTablesProps {
  /**
   * Row data for sales top ten ranking
   */
  salesRowData: TopTenResponse[];
  /**
   * Row data for purchase top ten ranking
   */
  purchaseRowData: TopTenResponse[];
  /**
   * Loading state for both tables
   */
  isLoading: boolean;
}

export function TopTenDataTables({
  salesRowData,
  purchaseRowData,
  isLoading
}: TopTenDataTablesProps) {
  const rowSelection = useMemo(() => ROW_SELECTION_CONFIG, []);

  const hitRate = useCalculateHitRate(salesRowData, purchaseRowData, isLoading);

  const hasData = salesRowData.length > 0 && purchaseRowData.length > 0;
  const hitRateDisplay = isLoading ? "-" : !hasData ? "-" : hitRate.toFixed(0);

  const gridOptions = {
    rowHeight: 76,
    cellSelection: false,
    rowSelection: rowSelection,
    columnDefs: createColumnDefinitions()
  };

  return (
    <div className={styles.flexContainer}>
      <div className={styles.flexWrapper}>
        <div>{RANKING_LABELS.SALES}</div>
        <div>
          {RANKING_LABELS.HIT_RATE}: {hitRateDisplay}%
        </div>
        <div>{RANKING_LABELS.PURCHASE}</div>
      </div>
      <div className={styles.flexWrapper}>
        <div className={styles.flexItem}>
          <DataTable
            gridOptions={gridOptions}
            rowData={salesRowData}
            loading={isLoading}
            grandTotalRow="bottom"
            getRowStyle={(params) =>
              getRowStyleForCrossTableComparison(params, purchaseRowData)
            }
          />
        </div>
        <div className={styles.flexItem}>
          <DataTable
            loading={isLoading}
            gridOptions={gridOptions}
            grandTotalRow="bottom"
            rowData={purchaseRowData}
            getRowStyle={(params) =>
              getRowStyleForCrossTableComparison(params, salesRowData)
            }
          />
        </div>
      </div>
    </div>
  );
}
